if(!customElements.get('results-component')) {
  customElements.define(
    'results-component',
    class ResultsComponent extends HTMLElement {
      /** Elements */
      #resultsGrid;
      #resultsCount;
      #sorter;
      #cleaner;
      #pagination;

      /** Pagination */
      #currentPage;
      #onNavigate;

      constructor() {
        super();
      }

      connectedCallback() {
        this.#resultsGrid = this.querySelector('[data-results]');
        if(!this.#resultsGrid) return;

        this.#resultsCount = this.querySelector('[data-results-count]');
        this.#sorter = this.querySelector('[name="sort_by"]');
        this.#cleaner = this.querySelector('[data-clear-filters]');
        this.#pagination = this.querySelector('[data-pagination]');

        this.#wirePagination();
        this.#wireClearFilters();

        this.addEventListener('query:change', (evt) => {
          const purgeFilters = evt.detail?.purgeFilters ?? false;
          if(purgeFilters) this.#currentPage = 1;
          this.#onQueryChange({ purgeFilters });
        });

      }

      async #onQueryChange(opts) {
        const params = this.#buildSearchParams(opts?.purgeFilters);
        const url = `${this.dataset.baseUrl}?${params.toString()}`;
        
        try {
          const response = await fetch(url);
          if(!response.ok) return console.error('Fetch failed');

          const html = await response.text();

          this.#updateResults(html);
          this.#updateUrl(url);
        } catch(err) {
          console.error('Error fetching results', err);
        } finally {
          
        }
      }

      #buildSearchParams(opts) {
        const params = new URLSearchParams();

        params.set('sort_by', this.#sorter.value ?? '');
        params.set('page', this.#currentPage || 1);

        if(!opts?.purgeFilters) {
          const filterInputs = this.querySelectorAll('[data-filter]');

          let priceMin = null;
          let priceMax = null;
          let priceMaxAllowed = null;

          filterInputs.forEach(input => {
            if ((input.type === 'checkbox' || input.type === 'radio') && input.checked) {
              params.append(input.name, input.value);
            }

            if (input.type === 'range' && input.dataset.filterType === 'price') {
              const value = parseFloat(input.value);
              if (input.dataset.priceBound === 'min') {
                priceMin = value;
              }

              if (input.dataset.priceBound === 'max') {
                priceMax = value;
                priceMaxAllowed = parseFloat(input.max);
              }
            }
          });

          if (priceMin !== null && priceMin > 0) {
            params.set('filter.v.price.gte', priceMin);
          }

          if (
            priceMax !== null &&
            priceMaxAllowed !== null &&
            priceMax < priceMaxAllowed
          ) {
            params.set('filter.v.price.lte', priceMax);
          }
        }

        return params;
      }

      #updateUrl(url) {
        history.pushState({}, '', url);
      }

      #updateResults(html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const newResults = doc.querySelector('[data-results]');
        if(newResults) {
          this.#resultsGrid.replaceWith(newResults);
          this.#resultsGrid = newResults;
        }

        if(this.#resultsCount) {
          const newCount = doc.querySelector('[data-results-count]');
          if(!newCount) return;

          this.#resultsCount.replaceWith(newCount);
          this.#resultsCount = newCount;
        }

        if(this.#pagination) {
          const newPagination = doc.querySelector('[data-pagination]');
          if(!newPagination) return;

          this.#pagination.replaceWith(newPagination);
          this.#pagination = newPagination;
          this.#wirePagination();
        }
      }

      #wirePagination() {
        if(!this.#pagination) return;

        this.#pagination.addEventListener('click', (e) => {
          const pageEl = e.target.closest('[data-page]');
          if (!pageEl) return;

          e.preventDefault();
          this.#currentPage = pageEl.dataset.page;
          this.#onQueryChange();
        });
      }

      #wireClearFilters() {
        if(!this.#cleaner) return;

        this.#cleaner.addEventListener('click', () => {
          this.#onQueryChange({ purgeFilters: true })
        });
      }
    }
  );
}